export default __webpack_public_path__ + "static/media/banner5.098ba6d7.webp";